import institutionAPI from 'services/institutionAPI'

type Params = {
  jobsiteId: string
}

export default async function getJobsiteOnCustomForm({ jobsiteId }: Params) {
  const response = await institutionAPI({
    method: 'GET',
    url: `/citizen-portal/service/jobsite/${jobsiteId}`,
  })

  return response
}
